<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <div slot="title">
            <div class="title-online">
              <h1 style="color:#323a3f;">在线用户</h1>
              <h1 style="color:#4a91e9;">
                <Icon type="logo-windows"/>
                PC {{ tableCount.pc_count }}
              </h1>
              <h1 style="color:#4a91e9;">
                <Icon type="ios-phone-portrait" size='30'/>
                手机网页 {{ tableCount.h5_count }}
              </h1>
              <h1 style="color:#6fbf75;">
                <Icon type="logo-android" size='30'/>
                安卓 {{ tableCount.android_count }}
              </h1>
              <h1 style="color:#919296;">
                <Icon type="logo-apple" size='30'/>
                苹果&nbsp;{{ tableCount.ios_count }}
              </h1>
              <h1 style="color:#1cb349;">
                <Icon type="md-person" size='30'/>
                会员&nbsp;{{ tableCount.vip_count }}
              </h1>
            </div>
          </div>
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.username' :placeholder="$t('请输入会员帐号') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select v-model='searchConf.last_login_device' clearable
                                                      :placeholder="$t('请选择所在端') " style='width:120px'>
              <Option :value="'0'">{{ $t('手机网页') }}</Option>
              <Option :value="'1'">{{ $t('安卓') }}</Option>
              <Option :value="'2'">{{ $t('苹果') }}</Option>
              <Option :value="'3'">{{ $t('PC网页') }}</Option>
            </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select v-model='searchConf.userType' clearable :placeholder="$t('帐号类型') "
                                                      style='width:120px'>
              <Option :value="'0'">{{ $t('本站玩家') }}</Option>
              <Option :value="'1'">{{ $t('代理玩家') }}</Option>
              <Option :value="'2'">{{ $t('测试帐号') }}</Option>
            </Select>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <!-- DATA -->
          <div>
            <Table :loading='listLoading' :columns='columnsList' :data='tableData' border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->

    <!--    -->
  </div>
</template>
<script>
import {
  getList
} from '@/api/userManage/listOnLine'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [
        {
          title: this.$t('ID'),
          key: 'id',
          minWidth: 15,
          align: 'center'
        }, {
          title: this.$t('用户信息'),
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('帐号') + ':' + params.row.username), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('类型') + ':' + params.row.user_type), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('层级') + ':' + params.row.level_name), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('等级') + ':' + params.row.grade_name),])
          }
        }, {
          title: this.$t('代理信息'),
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('代理级') + ':' + params.row.proxy_level), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('上级') + ':' + params.row.top_username), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('下级人数') + ':' + params.row.low_count),])
          }
        }, {
          title: this.$t('余额'),
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('余额') + ':' + params.row.account_money), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('余额宝') + ':' + params.row.yeb_all_money)])
          }
        }, {
          title: this.$t('盈亏'),
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('平台总盈亏') + ':' + params.row.ptTotalWin),])
          }
        }, {
          title: this.$t('存取款'),
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('总充值') + ':' + params.row.all_recharge), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('总提现') + ':' + params.row.all_withdraw)])
          }
        }, {
          title: this.$t('每日任务'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('任务派奖') + ':' + params.row.game_profit), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('任务返佣') + ':' + params.row.game_fan),])

          }
        }, {
          title: this.$t('余额宝'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('利息派送') + ':' + params.row.yeb_profit), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('转入') + ':' + params.row.yeb_to_yeb), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('转出') + ':' + params.row.yeb_to_account)])

          }
        }, {
          title: this.$t('VIP'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP消费总额') + ':' + params.row.game_buy_vip), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP押金返还') + ':' + params.row.game_back_vip), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP1次数') + ':' + params.row.game_buy_vip1_user), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP2次数') + ':' + params.row.game_buy_vip2_user), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP3次数') + ':' + params.row.game_buy_vip3_user)])

          }
        }, {
          title: this.$t('VIP'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP4次数') + ':' + params.row.game_buy_vip4_user), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP5次数') + ':' + params.row.game_buy_vip5_user), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('VIP6次数') + ':' + params.row.game_buy_vip6_user)])

          }
        }, {
          title: this.$t('赠送礼金'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('人工赠送') + ':' + params.row.rengong_send), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('活动赠送') + ':' + params.row.huodong_send), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('充值赠送') + ':' + params.row.recharge_send), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('总赠送') + ':' + params.row.all_send),])
          }
        }, {
          title: this.$t('最后登陆信息'),
          align: 'center',
          minWidth: 160,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('登陆IP') + ':' + params.row.last_login_ip), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('登陆地区') + ':' + params.row.last_login_address), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('登陆时间') + ':' + params.row.last_login_time), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('最后操作') + ':' + params.row.lastvisit),])
          }
        }, {
          title: this.$t('是否锁定 '),
          align: 'center',
          minWidth: 80,

          key: 'is_lock',
          render: (h, params) => {
            if (params.row.is_lock == 1) {
              return h('div', [
                h('span', {
                  props: {
                    type: 'error',
                  },
                  style: {
                    color: '#ed4014',
                    borderRadius: '11px',
                    border: '1px solid #ed4014',
                    display: 'block',
                    height: '25px',
                    width: '70%',
                    lineHeight: '25px',
                    margin: 'auto'
                  },
                }, this.$t(' 锁定')),

              ])
            } else {
              return h('div', [
                h('span', {
                  props: {
                    type: 'success',
                  },
                  style: {
                    color: '#19be6b',
                    borderRadius: '11px',
                    border: '1px solid #19be6b',
                    display: 'block',
                    height: '25px',
                    width: '70%',
                    lineHeight: '25px',
                    margin: 'auto'
                  },
                }, this.$t(' 正常 ')),
              ])
            }
          }
        }, {
          title: this.$t('其它信息'),
          align: 'center',
          minWidth: 160,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('手机号') + ':' + params.row.mobile), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('注册时间') + ':' + params.row.register_time),
              h('p', {
                style: {
                  textAlign: 'left',
                  marginLeft: '5px'
                }
              }, this.$t('过期日期') + ':' + params.row.vip_expire_time), h('p', {
                style: {
                  textAlign: 'left',
                  marginLeft: '5px'
                }
              }, this.$t('首充时间') + ':' + params.row.first_recharge_day), h('p', {
                style: {
                  textAlign: 'left',
                  marginLeft: '5px'
                }
              }, this.$t('渠道') + ':' + params.row.channel), h('p', {
                style: {
                  textAlign: 'left',
                  marginLeft: '5px'
                }
              }, this.$t('备注') + ':' + params.row.remark),])
          }
        },],
      tableData: [],//用于放LIST数据绑定
      tableCount: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('userManage/listOnLine/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('userManage/listOnLine/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('userManage/listOnLine/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  methods: {
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.tableCount.h5_count = response.data.data.h5_count
        vm.tableCount.android_count = response.data.data.android_count
        vm.tableCount.ios_count = response.data.data.ios_count
        vm.tableCount.pc_count = response.data.data.pc_count
        vm.tableCount.vip_count = response.data.data.vip_count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
  }
}
</script>
<style lang="less" scoped>
.title-online {
  h1 {
    display: inline-block;
    margin-right: 30px;
    vertical-align: bottom;
  }

  .ivu-icon {
    padding-right: 5px;
  }
}

/deep/ .ivu-icon {
  vertical-align: text-bottom;
}
</style>
